export default {
  // START:: SET APP THEME
  setAppTheme(state, payload) {
    state.Fans_admin_dashboard_theme = payload;
  },
  // END:: SET APP THEME
};
